import { BaseService } from "./BaseService";
import type {
  TeamsAnalyticsRangeQuery,
  TeamsExportQuery,
  TeamsOverviewResponse,
  TeamsStaffSeriesResponse,
  TeamsTopExportQuery,
  TeamsTopQuery,
  TeamsTopResponse,
} from "@/types/analytics-teams";

class AnalyticsTeamsService extends BaseService {
  private readonly basePath = "/analytics/teams";

  getOverview(query: TeamsAnalyticsRangeQuery): Promise<TeamsOverviewResponse> {
    return this.get<TeamsOverviewResponse>(`${this.basePath}/overview`, query);
  }

  getTop(query: TeamsTopQuery): Promise<TeamsTopResponse> {
    return this.get<TeamsTopResponse>(`${this.basePath}/top`, query);
  }

  getStaffSeries(
    staffId: string,
    query: TeamsAnalyticsRangeQuery,
  ): Promise<TeamsStaffSeriesResponse> {
    return this.get<TeamsStaffSeriesResponse>(
      `${this.basePath}/staff/${staffId}/series`,
      query,
    );
  }

  exportOverview(query: TeamsExportQuery): Promise<Blob> {
    return this.getBlob(`${this.basePath}/overview/export`, query);
  }

  exportTop(query: TeamsTopExportQuery): Promise<Blob> {
    const { entity, ...rankingQuery } = query;
    const rankingPath = entity === "STAFF" ? "staff" : "team";

    return this.getBlob(
      `${this.basePath}/top/${rankingPath}/export`,
      rankingQuery,
    );
  }
}

export const analyticsTeamsService = new AnalyticsTeamsService();
